module.exports = __webpack_public_path__ + "static/media/panel_identificador_prestador.00f4b362.svg";